var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 60,
    viewBox: "0 0 230 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230 0H0V60H230V0Z",
    fill: "#6A43B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.051 58.2871L221 54.7647L221.158 5.1441L227.051 1.71277V58.2871Z",
    fill: "#BF8FB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221 54.7648L227.051 58.2871H2.94946L9.93036 54.2299L221 54.7648Z",
    fill: "#BF8FB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94946 1.71277L9.00001 5.23515L8.84825 54.8558L2.94946 58.2871V1.71277Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 5.23515L2.94946 1.71277H227.051L220.076 5.77005L9.00001 5.23515Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.108 3.43127H5.89893V56.5743H224.108V3.43127Z",
    fill: "#FFDAF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.cf04817777bd960a24d99078f37a98fa.svg";
export { ForwardRef as ReactComponent };